// Brand monogram + wordmark. `size` is the monogram height in px.
export const Logo = ({ size = 22, showWord = true, className = "" }) => (
  <span className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <img
      src="/logo-mark.webp"
      alt="Strict RR logo"
      width={Math.round(size * 2.327)}
      height={size}
      style={{ height: size, width: Math.round(size * 2.327) }}
      className="select-none"
      draggable="false"
      fetchPriority="high"
    />
    {showWord && (
      <span className="font-heading font-bold tracking-tight whitespace-nowrap">STRICT RR</span>
    )}
  </span>
);

export default Logo;
